// Les descriptions sont maintenant dans translations.js

export const projectsData = [
  { 
    id: 9, 
    title: 'Résidence "Le Chemin des Vignes"', 
    location: 'Port la Nouvelle', 
    category: 'collective', 
    image: '/images/projets/chemindesvignes/4.webp',
    images: [
      '/images/projets/chemindesvignes/4.webp',
      '/images/projets/chemindesvignes/5.webp',
    ]
  },
  { 
    id: 4, 
    title: 'Résidence Cité Marcadal', 
    location: 'Florensac', 
    category: 'collective',
    image: '/images/projets/marcadal/3.webp',
    images: [
      '/images/projets/marcadal/2.webp',
      '/images/projets/marcadal/3.webp',
      '/images/projets/marcadal/5.webp',
    ]
  },
  { 
    id: 8, 
    title: 'Résidence "Patio Clément"', 
    location: 'Mauguio', 
    category: 'collective', 
    image: '/images/projets/patioclement/1.webp',
    images: [
      '/images/projets/patioclement/1.webp',
      '/images/projets/patioclement/2.webp',
      '/images/projets/patioclement/3.webp',
      '/images/projets/patioclement/4.webp',
      '/images/projets/patioclement/5.webp',
      '/images/projets/patioclement/6.webp',
      '/images/projets/patioclement/7.webp',
      '/images/projets/patioclement/8.webp',
      '/images/projets/patioclement/9.webp',
      '/images/projets/patioclement/10.webp',
      '/images/projets/patioclement/11.webp',
      '/images/projets/patioclement/12.webp',
      '/images/projets/patioclement/13.webp',
      '/images/projets/patioclement/14.webp',
      '/images/projets/patioclement/15.webp',
    ]
  },
  { 
    id: 6, 
    title: 'Résidence La Vigneronne', 
    location: 'Maureilhan', 
    category: 'collective', 
    image: '/images/projets/vigneronne/1.webp',
    images: [
      '/images/projets/vigneronne/1.webp',
      '/images/projets/vigneronne/2.webp',
      '/images/projets/vigneronne/3.webp',
      '/images/projets/vigneronne/4.webp',
      '/images/projets/vigneronne/5.webp',
      '/images/projets/vigneronne/6.webp',
    ]
  },
  { 
    id: 3, 
    title: 'Résidence Pélissier', 
    location: 'Mauguio', 
    category: 'collective', 
    image: '/images/projets/pelissier/1.webp',
    images: [
      '/images/projets/pelissier/1.webp',
      '/images/projets/pelissier/2.webp',
      '/images/projets/pelissier/3.webp',
      '/images/projets/pelissier/4.webp',
      '/images/projets/pelissier/5.webp',
      '/images/projets/pelissier/6.webp',
      '/images/projets/pelissier/7.webp',
      '/images/projets/pelissier/8.webp',
      '/images/projets/pelissier/9.webp',
    ]
  },
  {
    id: 1, 
    title: 'Zac PIERRES VIVES - Résidence Alfred Screve', 
    location: 'Montpellier', 
    category: 'collective', 
    image: '/images/projets/pierre-vives/1.webp',
    images: [
      '/images/projets/pierre-vives/1.webp',
      '/images/projets/pierre-vives/2.webp',
      '/images/projets/pierre-vives/3.webp',
      '/images/projets/pierre-vives/4.webp',
      '/images/projets/pierre-vives/5.webp',
      '/images/projets/pierre-vives/6.webp',
    ]
  },
  { 
    id: 2, 
    title: 'ZAC OVALIE Lot 23 C2 - Résidence Park View', 
    location: 'Montpellier', 
    category: 'collective', 
    image: '/images/projets/ovalie/1.webp',
    images: [
      '/images/projets/ovalie/1.webp',
      '/images/projets/ovalie/2.webp',
      '/images/projets/ovalie/3.webp',
      '/images/projets/ovalie/4.webp',
      '/images/projets/ovalie/5.webp',
      '/images/projets/ovalie/6.webp',
      '/images/projets/ovalie/7.webp',
      '/images/projets/ovalie/8.webp',
      '/images/projets/ovalie/9.webp',
    ]
  },
  { 
    id: 5, 
    title: 'Résidence Les Semailles', 
    location: 'Maraussan', 
    category: 'collective', 
    image: '/images/projets/semailles/1.webp',
    images: [
      '/images/projets/semailles/1.webp',
      '/images/projets/semailles/2.webp',
      '/images/projets/semailles/3.webp',
      '/images/projets/semailles/4.webp',
      '/images/projets/semailles/5.webp',
      '/images/projets/semailles/6.webp',
    ]
  },
  { 
    id: 7, 
    title: 'Logements', 
    location: 'Frontignan', 
    category: 'collective', 
    image: '/images/projets/logements-frontignan/1.webp'
  },
  { 
    id: 10, 
    title: 'Maison Individuelle', 
    location: 'Baillargues', 
    category: 'individual', 
    image: '/images/projets/maisonbaillargue/2.webp',
    images: [
      // '/images/projets/maisonbaillargue/1.webp',
      '/images/projets/maisonbaillargue/2.webp',
      '/images/projets/maisonbaillargue/3.webp',
      '/images/projets/maisonbaillargue/4.webp',
      '/images/projets/maisonbaillargue/5.webp',
    ]
  },
  { 
    id: 11, 
    title: 'Maison Individuelle Ossature Bois BBC', 
    location: 'Mondonville', 
    category: 'individual', 
    image: '/images/projets/maisonbbc/1.webp',
    images: [
      '/images/projets/maisonbbc/1.webp',
      '/images/projets/maisonbbc/2.webp',
      '/images/projets/maisonbbc/3.webp',
      '/images/projets/maisonbbc/4.webp',
    ]
  },
  { 
    id: 14, 
    title: 'Stade René Franqués', 
    location: 'Florensac', 
    category: 'territory', 
    image: '/images/projets/staderene/01.webp',
    images: [
      '/images/projets/staderene/02.webp',
      '/images/projets/staderene/03.webp',
      '/images/projets/staderene/04.webp',
      '/images/projets/staderene/05.webp',
      '/images/projets/staderene/06.webp',
      '/images/projets/staderene/5.webp',
    ]
  },
  { 
    id: 13, 
    title: 'Poste de Police Municipale', 
    location: 'Baillargues', 
    category: 'territory', 
    image: '/images/projets/policebaillargue/1.webp',
    images: [
      '/images/projets/policebaillargue/1.webp',
      '/images/projets/policebaillargue/2.webp',
      '/images/projets/policebaillargue/3.webp',
      '/images/projets/policebaillargue/4.webp',
      '/images/projets/policebaillargue/5.webp',
      '/images/projets/policebaillargue/6.webp',
      '/images/projets/policebaillargue/7.webp',
      '/images/projets/policebaillargue/8.webp',
    ]
  },
  { 
    id: 12, 
    title: 'Local associatif - Club House Stade', 
    location: 'Baillargues', 
    category: 'territory', 
    image: '/images/projets/clubstade/1.webp',
    images: [
      '/images/projets/clubstade/1.webp',
      '/images/projets/clubstade/2.webp',
      '/images/projets/clubstade/3.webp',
      '/images/projets/clubstade/4.webp',
      '/images/projets/clubstade/5.webp',
      '/images/projets/clubstade/6.webp',
      '/images/projets/clubstade/7.webp',
      '/images/projets/clubstade/8.webp',
    ]
  },
  { 
    id: 15, 
    title: 'Concours - ZAC CAMBACERES, Lot B1.1', 
    location: 'Montpellier', 
    category: 'competitions', 
    image: '/images/projets/cambaceres/2.webp',
    images: [
      '/images/projets/cambaceres/1.webp',
      '/images/projets/cambaceres/2.webp',
      '/images/projets/cambaceres/3.webp',
      '/images/projets/cambaceres/4.webp',
    ]
  },
  { 
    id: 17, 
    title: 'Concours - Secteur Martinet "Coeur de village"', 
    location: 'Langlade', 
    category: 'competitions', 
    image: '/images/projets/martinet/1.webp',
    images: [
      '/images/projets/martinet/1.webp',
      '/images/projets/martinet/2.webp',
      '/images/projets/martinet/3.webp',
      '/images/projets/martinet/4.webp',
    ]
  },
  { 
    id: 20, 
    title: 'Concours - ZAC Carrière des Amoureux Macrolot A', 
    location: 'Garons', 
    category: 'competitions', 
    image: '/images/projets/macrolotA/2.webp',
    images: [
      '/images/projets/macrolotA/2.webp',
      '/images/projets/macrolotA/3.webp',
      '/images/projets/macrolotA/4.webp',
      '/images/projets/macrolotA/5.webp',
      '/images/projets/macrolotA/6.webp',
      '/images/projets/macrolotA/1.webp',
    ]
  },
  { 
    id: 16, 
    title: 'Concours - Avenue de la Gardie', 
    location: 'Florensac', 
    category: 'competitions', 
    image: '/images/projets/lagardie/4.webp',
    images: [
      '/images/projets/lagardie/2.webp',
      '/images/projets/lagardie/3.webp',
      '/images/projets/lagardie/4.webp',
      '/images/projets/lagardie/1.webp',
      '/images/projets/lagardie/5.webp',
    ]
  },
  { 
    id: 21, 
    title: 'Concours - ZAC "Puit de Rouille", Lot 7', 
    location: 'Nîmes', 
    category: 'competitions', 
    image: '/images/projets/puitderouille/1.webp',
    images: [
      '/images/projets/puitderouille/1.webp',
      '/images/projets/puitderouille/2.webp',
      '/images/projets/puitderouille/3.webp',
    ]
  },
  { 
    id: 19, 
    title: 'Concours - Ilot St Esprit', 
    location: 'Bézier', 
    category: 'competitions', 
    image: '/images/projets/ilot/1.webp',
    images: [
      '/images/projets/ilot/1.webp',
      '/images/projets/ilot/2.webp',
      '/images/projets/ilot/3.webp',
      '/images/projets/ilot/4.webp',
    ]
  },
  { 
    id: 18, 
    title: 'Concours - ZAC Carrière des Amoureux Macrolot C', 
    location: 'Garons', 
    category: 'competitions', 
    image: '/images/projets/macrolotC/2.webp',
    images: [
      '/images/projets/macrolotC/1.webp',
      '/images/projets/macrolotC/2.webp',
      '/images/projets/macrolotC/3.webp',
    ]
  },
  { 
    id: 22, 
    title: 'Étude Concept - Microstation dédiée (GAZ GNV)', 
    location: 'Occitanie', 
    category: 'territory', 
    image: '/images/projets/concept/1.webp',
    images: [
      '/images/projets/concept/1.webp',
      '/images/projets/concept/2.webp',
    ]
  },
  { 
    id: 23, 
    title: 'Réalisation d’un programme immobilier de 50 logements', 
    location: 'Narbonne', 
    category: 'competitions', 
    image: '/images/projets/narbonne/1.webp',
    images: [
      '/images/projets/narbonne/1.webp',
      '/images/projets/narbonne/2.webp',
    ]
  },
];

// Actualités
// L'ordre d'affichage sur /news est calculé par date (News.jsx), pas par la position ici.
// Les articles tirent leur date de articlesData (dateISO) ; les parutions presse la portent ici.
export const newsData = [
  {
    id: 1,
    dateISO: '2019-10-15',
    pdf: '/pdfs/PARKVIEW.pdf',
    project: 'ovalie'
  },
  {
    id: 2,
    dateISO: '2019-10-10',
    pdf: '/pdfs/COGIM_OVALIE.pdf',
    project: 'ovalie'
  },
  {
    id: 3,
    dateISO: '2019-05-15',
    pdf: '/images/projets/stadebaillargues/1.webp',
    project: 'Baillargues'
  },
  {
    id: 7,
    articleSlug: 'zan-zero-artificialisation-nette-herault',
    project: 'herault'
  },
  {
    id: 8,
    articleSlug: 'architecture-bioclimatique-mediterraneenne-herault',
    project: 'herault'
  },
  {
    id: 9,
    articleSlug: 'renovation-energetique-passoires-thermiques-herault',
    project: 'herault'
  },
  {
    id: 4,
    articleSlug: 're2020-herault-architecture-durable',
    project: 'herault'
  },
  {
    id: 5,
    articleSlug: 'logements-collectifs-montpellier-herault',
    project: 'montpellier'
  },
  {
    id: 6,
    articleSlug: 'maison-individuelle-herault-architecte-dplg',
    project: 'herault'
  },
  {
    id: 10,
    articleSlug: 'extension-agrandissement-maison-herault',
    project: 'herault'
  },
  {
    id: 11,
    articleSlug: 'permis-construire-declaration-prealable-herault',
    project: 'herault'
  }
];